import DPFBlurredBackground from '../assets/landing/blurred-background.png'

export default function EmotionalClosingSection() {
  return (
    <section className='relative px-4 py-[70px] overflow-hidden'>
      <img
        src={DPFBlurredBackground}
        alt=''
        className='absolute inset-0 w-full h-full object-cover'
        loading='lazy'
        aria-hidden='true'
      />

      <div className='relative text-center'>
        <div className='text-gray-12 leading-relaxed'>
          <p className='text-base font-normal'>映し出されるたびに、愛しさがあふれる</p>
          <br />
          <p className='text-base font-normal'>家族をつなぐ、</p>
          <p className='text-base font-normal'>かけがえのない日々の記録。</p>
          <br />
          <p className='text-base font-normal'>おもいでフォトフレームは</p>
          <p className='text-base font-normal'>日常にそっと寄り添い</p>
          <p className='text-base font-normal'>家族の思い出を昨日から今日へ</p>
          <p className='text-base font-normal'>やさしくつなぎます</p>
        </div>
      </div>
    </section>
  )
}
